// IMPORT REACT
import React from 'react';
import Axios from 'axios';

// IMPORT COMPONENTS
import YAText from '../../Text';
import YARow from '../../Grid/Row';
import YAColumn from '../../Grid/Column';
import YAButton from '../../Form/Button';
import YASubmit from '../../Form/Submit';
import YAIcon from '../../Icon';
import YAInput from '../../Form/Input';
import YAAlert from '../../Alert';

// IMPORT STYLES
import { SC_Folder, SC_IconContainer } from '../styles';


class YAFolder extends React.Component {

	constructor(props) {
		super();
		this.state = {
			formError: null,
			formSuccess: null,
			allPermissions: [],
			allCategories: [],
		};
	}

	componentDidMount() {

		this.getCategories('en').then(data => {
			this.setState({
				allCategories: data,
			});
		});

		this.getPermissions('en').then(data => {
			this.setState({
				allPermissions: data,
			});
		});

	}

	editCategory(e, remove) {
		e.preventDefault();
		let url = '/wp-json/wp/v2/weemarkable/category-manage/';
		let form = document.getElementById("edit_category_form");
		let data = new FormData(form);
		data.append('cat_id', this.props.category.term_id);
		if (remove) {
			data.append('delete', this.props.category.term_id);
		}
		return Axios({
			method: 'post',
			url: url,
			data: data,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getPermissions(lang) {
		let url = '/wp-json/wp/v2/weemarkable/permissions/';
		url += '?lang=';
		url += lang;
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getCategories(lang) {
		let url = '/wp-json/wp/v2/weemarkable/categories/';
		url += '?lang=';
		url += lang;
		url += '&parent=any';
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	render() {
		const category = this.props.category;

		const id = category.term_id;
		const title = category.name;
		const itemCount = category.count;
		const guid = category.guid;

		let formError = this.state.formError;
		let allCategories = this.state.allCategories;
		let allPermissions = this.state.allPermissions;
		let cancelCallbackFunction = this.props.cancelCallbackFunction;
		let selectedCategory = this.props.selectedCategory;
		let startEditingCallbackFunction = this.props.startEditingCallbackFunction;
		let isWeemarkableSuperAdmin = this.props.isWeemarkableSuperAdmin;

		let editing = this.props.editing;

		let categoriesOptions = allCategories && allCategories.length ? allCategories.map((category) => {
			return ({
				id: category.slug,
				label: category.ancestors + ' ' + category.name_english,
				value: category.term_id,
			});
		}) : null;

		let permissionsOptions = allPermissions && allPermissions.length ? allPermissions.map((permission) => {
			const index = category.permissions.findIndex(x => x.meta_key === permission.meta_key);
			return ({
				id: 'edit_' + permission.meta_key,
				value: category.permissions[index].value,
				label: permission.meta_label
			});
		}) : null;

		return (
			<SC_Folder>
				<YARow center="vertical">
					<YAColumn size="col-auto" autoWidth>
						<SC_IconContainer>
							<YAIcon icon="folder" height="100px" fill="ymcaOrangeDark" altFill="ymcaOrangeBright" />
						</SC_IconContainer>
					</YAColumn>
					<YAColumn autoWidth>
						<YAButton color="link" bootstrap="text-left" to={guid}>
							{title}
						</YAButton>
					</YAColumn>
					<YAColumn size="col-auto" autoWidth>
						<YAText addOn={' Files'}>
							{itemCount}
						</YAText>
					</YAColumn>
					<YAColumn size="col-auto" autoWidth>
						{isWeemarkableSuperAdmin && (editing && editing == id) &&
							<YAButton size="sm" color="dark" onClick={() => { cancelCallbackFunction() }}>
								Cancel
						</YAButton>
						}
						{isWeemarkableSuperAdmin && (!editing || editing != id) &&
							<YAButton size="sm" color="dark" onClick={() => { startEditingCallbackFunction(id) }}>
								Edit
						</YAButton>
						}
						{(!editing || editing != id) &&
							<YAButton size="sm" color="outline-dark" to={guid}>
								Open
						</YAButton>
						}
					</YAColumn>
				</YARow>

				{isWeemarkableSuperAdmin && (editing && editing == id) &&
					<form id="edit_category_form" onSubmit={(e) => {
						this.editCategory(e).then(data => {
							if (data.error) {
								this.setState({
									formSuccess: null,
									formError: data.error
								})
							} else if (data.success) {
								this.setState({
									formError: null
								})
								cancelCallbackFunction(data.success)
							}
						});
					}}>
						{formError &&
							<YAAlert color="danger">
								{formError}
							</YAAlert>}

						<YAInput type="text" id="edit_name_en" label="Folder Name - English" value={category.name_english} />
						<YAInput type="text" id="edit_name_fr" label="Folder Name - French" value={category.name_french} />
						<YAInput type="select" id="edit_parent" label="Parent Folder" value={category.parent} options={categoriesOptions} />
						<YAInput type="checkbox" label="Permissions" options={permissionsOptions} />

						<YAButton color="danger" onClick={(e) => {
							e.preventDefault();
							var confirmDelete = window.confirm("Are you sure you want to delete this folder?");
							if (confirmDelete == true) {
								this.editCategory(e, true).then(data => {
									if (data.error) {
										this.setState({
											formSuccess: null,
											formError: data.error
										})
									} else if (data.success) {
										this.setState({
											formError: null
										})
										cancelCallbackFunction(data.success)
									}
								});
							}
						}}>
							Delete
					</YAButton>
						<YASubmit color="success" value="Save" />

						<br />	<br />
					</form>}

			</SC_Folder>
		)
	}
}
export default YAFolder;